import { makeStyles } from 'tss-react/mui'

export const fieldFormStyles = makeStyles()(theme => ({
  container: {
    marginTop: '47px'
  },
  globalFiltersContainer: {
    height: '72px',
    margin: '0px',
    padding: '0px',
    width: '100%',
    maxWidth: '100%'
  },
  SearchInput: {
    borderRadius: 8,
    paddingRight: 0,
    '& .MuiInputBase-root': {
      '& input': {
        fontSize: '12px'
      }
    },
    '& .MuiInputBase-input': {
      fontSize: '12px'
    },
    '&.MuiOutlinedInput-root': {
      '&:hover fieldset': {
        borderColor: 'rgba(0, 0, 0, 0.23)'
      }
    },
    height: '32px',
    width: '330px'
  },
  datesInput: {
    height: '32px'
  },
  Counts: {
    fontSize: '12px',
    fontWeight: '400'
  },
  select: {
    '&:focus': {
      backgroundColor: theme.colors.transparent,
      padding: '0px 0px'
    }
  },
  selector: {
    height: '32px',
    fontSize: '12px',
    '& .MuiSelect-outlined': {
      paddingRight: '0px'
    }
  },
  exportButton: {
    marginLeft: '15px',
    color: theme.palette.primary.main,
    fontSize: '14px',
    fontWeight: '700',
    textTransform: 'none',
    padding: '0px 0px',
    marginTop: '1px'
  },
  advancedButton: {
    paddingBottom: '5px',
    color: theme.palette.primary.main,
    fontSize: '14px',
    fontWeight: '700',
    textTransform: 'none',
    marginLeft: '15px',
    marginTop: '-20px'
  },
  resetButton: {
    color: theme.palette.primary.main,
    fontSize: '14px',
    fontWeight: '700',
    textTransform: 'none',
    marginLeft: '10px'
  },
  tableContainer: {
    width: '100%',
    maxWidth: '100%'
  },
  countsContainer: {
    margin: '0px 54px',
    padding: '0px 0px'
  },
  exportDialog: {
    borderRadius: '8px'
  },
  exportTitle: {
    color: theme.colors.text,
    fontSize: '20px',
    fontWeight: 'bold',
    margin: '33px 0px',
    textAlign: 'center'
  },
  exportContent: {
    color: theme.colors.text,
    fontSize: '14px',
    fontWeight: 'normal',
    textAlign: 'center',
    width: '389px',
    margin: '0px 35px 33px 35px'
  },
  dialogButton: {
    marginLeft: 'auto',
    height: '40px',
    width: '84px',
    fontSize: '14px'
  },
  dialogContent: {
    display: 'flex !important'
  },
  serviceBox: {
    marginRight: '1px',
    textAlign: 'right'
  },
  fieldFormsText: {
    letterSpacing: '1px',
    fontFamily: 'Rubik',
    lineHeight: '24px',
    fontSize: '20px',
    fontWeight: 700,
    color: '#000000',
    marginRight: '30px'
  },
  newFormButton: {
    fontSize: '12px',
    marginRight: '35px',
    fontFamily: 'Rubik'
  },
  actionsContainer: {
    alignItems: 'center',
    display: 'flex',
    paddingBottom: '20px',
    paddingLeft: '20px'
  }
}))

export const mainTableStyles = makeStyles()(theme => ({
  tableCellSkeleton: {
    paddingLeft: '8px',
    paddingRight: '14px',
    border: 0,
    width: '10%'
  },
  formCellSkeleton: {
    paddingLeft: '8px',
    paddingRight: '14px',
    border: 0,
    width: '17%'
  },
  linearProgressStyle: {
    width: '100%'
  },
  tableRowSkeleton: {
    height: '68px'
  },
  colorPrimary: {
    background: theme.colors.buttonPrimary
  },
  barColorPrimary: {
    background: `linear-gradient(to right, ${theme.colors.buttonPrimary},${theme.colors.gradient},${theme.colors.buttonPrimary})`
  },
  dimensions: {
    height: '21px',
    width: '100px'
  },
  tableContainer: {
    paddingRight: '20px',
    '&::-webkit-scrollbar': {
      display: 'none'
    },
    scrollbarWidth: 'none',
    '-ms-overflow-style': 'none',
    minWidth: '1440px',
    width: '100%',
    height: 'calc(100vh - 205px)'
  },
  tableText: {
    fontSize: 12,
    fontWeight: 500,
    fontFamily: 'Rubik',
    color: theme.colors.text,
    paddingRight: '12px'
  },
  tableCellActions: {
    width: '160px',
    maxWidth: '160px',
    border: 0
  },
  tableCellName: {
    width: '250px',
    maxWidth: '250px',
    border: 0
  },
  tableCell: {
    width: '150px',
    maxWidth: '150px',
    border: 0
  },
  emptyMessageCell: {
    borderBottom: 0
  },
  truncateText: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: '2',
    WebkitBoxOrient: 'vertical'
  },
  truncateTexOneLine: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: '1',
    WebkitBoxOrient: 'vertical'
  },
  formDescription: {
    fontSize: 12,
    fontWeight: 300
  },
  formTitle: {
    fontSize: 12,
    fontWeight: 600
  },
  separator: {
    border: `1px solid ${theme.colors.gray2}`
  },
  modalTitle: {
    color: theme.colors.loadingRing,
    fontSize: '24px',
    fontWeight: 700
  },
  modalMessage: {
    color: theme.colors.text,
    fontSize: '18px',
    fontWeight: 400,
    lineHeight: '20px'
  },
  modalMessagesContainer: {
    marginTop: '30px',
    marginBottom: '30px'
  },
  modalMessageExtra: {
    color: theme.colors.text,
    fontSize: '18px',
    fontWeight: 400,
    marginTop: '26px',
    lineHeight: '20px'
  },
  modalSecondaryButton: {
    borderRadius: '36px',
    width: '115px',
    textTransform: 'none',
    borderColor: theme.colors.logInDisabledBackground,
    color: theme.colors.text,
    fontSize: '14px',
    fontWeight: 700
  },
  modalSecondaryAlertButton: {
    marginLeft: '40%',
    borderRadius: '36px',
    width: '115px',
    textTransform: 'none',
    borderColor: theme.colors.redError,
    color: theme.colors.redError,
    fontSize: '14px',
    fontWeight: 700
  },
  modalMainButton: {
    marginLeft: '22px',
    borderRadius: '36px',
    width: '115px',
    textTransform: 'none',
    background: theme.colors.iconBlue,
    borderColor: theme.colors.iconBlue,
    color: 'white',
    fontSize: '14px',
    fontWeight: 700
  },
  modalButtonsContainer: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  tableSortLabel: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 12,
    fontWeight: 600,
    color: theme.colors.grayText,
    '&.MuiTableSortLabel-root': {
      color: theme.colors.darkRed
    },
    '&.MuiTableSortLabel-root:hover': {
      color: theme.colors.darkRed
    },
    '&.Mui-active': {
      color: theme.colors.darkRed
    },
    '& .MuiTableSortLabel-icon': {
      color: `${theme.colors.darkRed} !important`
    }
  },
  formNameText: {
    fontSize: 12,
    fontWeight: 600
  },
  chip: {
    fontSize: 12,
    marginRight: '4px'
  },
  emptyQueryBody: {
    marginTop: '80px',
    color: theme.colors.textButton,
    fontSize: '16px',
    fontWeight: '400',
    marginLeft: 'auto',
    marginRight: 'auto',
    display: 'flex',
    justifyContent: 'center',
    maxWidth: '1000px',
    textAlign: 'center'
  }
}))

export const dateFilterStyles = makeStyles()(theme => ({
  datePicker: {
    '& .MuiPickersModal-dialog': {
      backgroundColor: 'red !important'
    }
  },
  mainInput1: {
    ...theme.filtersClasses.mainInput1,
    cursor: 'pointer',
    caretColor: 'transparent',
    '& .MuiInputBase-input': {
      cursor: 'pointer !important'
    }
  },
  mainInput2: {
    ...theme.filtersClasses.mainInput2,
    cursor: 'pointer',
    caretColor: 'transparent',
    '& .MuiInputBase-input': {
      cursor: 'pointer !important'
    }
  }
}))

export const inputFieldFilterStyles = makeStyles()(theme => ({
  mainInput1: theme.filtersClasses.mainInput1,
  mainInput2: theme.filtersClasses.mainInput2
}))

export const slideFilterStyles = makeStyles()(theme => ({
  mainMenu: {
    '& .MuiPaper-root': {
      height: '350px'
    }
  },
  switch: {
    marginRight: '0px',
    marginLeft: 'auto',
    color: theme.colors.mainBlue
  },
  thumb: {
    width: '13px',
    height: '13px',
    marginTop: '3px',
    marginLeft: '3px'
  },
  select: {
    '&:focus': {
      backgroundColor: theme.colors.transparent,
      color: theme.colors.text
    }
  },
  input: {
    fontSize: '12px',
    backgroundColor: theme.colors.transparent,
    color: theme.colors.text,
    borderRadius: '8px',
    marginLeft: '0px'
  },
  notched: {
    border: 'none'
  },
  label: {
    fontSize: '12px',
    fontWeight: '400',
    maxWidth: '220px',
    textAlign: 'center'
  },
  progress: {
    width: '20px',
    height: '20px',
    display: 'flex'
  },
  mainInput1: {
    ...theme.filtersClasses.mainInput1,
    '& .MuiInputBase-input': {
      cursor: 'pointer !important'
    }
  },
  mainInput2: {
    ...theme.filtersClasses.mainInput2,
    '& .MuiInputBase-input': {
      cursor: 'pointer !important'
    }
  },
  searchInput1: theme.filtersClasses.searchInput1,
  searchInput2: theme.filtersClasses.searchInput2,
  menuItem: {
    ...theme.filtersClasses.menuItem,
    minWidth: '164px',
    whiteSpace: 'initial',
    wordBreak: 'break-word'
  }
}))

export const sortMenuStyles = makeStyles()(theme => ({
  menuItem: theme.filtersClasses.menuItem
}))

export const modalFormStyles = makeStyles()(theme => ({
  formControl: { width: '100%', fontSize: '12px' },
  titleContainer: { display: 'flex', marginTop: '10px', marginBottom: '5px' },
  titleSymbol: {
    fontSize: '12px',
    fontWeight: 400,
    color: theme.colors.redError
  },
  titleFontStyle: {
    fontSize: '12px',
    fontWeight: 400,
    color: theme.colors.textButton
  },
  selectStyle: { borderRadius: 30, height: '36px' },
  itemsFontStyle: { fontSize: '12px' },
  iconStyle: {
    fontSize: '14px',
    fontWeight: 500,
    color: theme.colors.text
  },
  formHelperTextStyle: {
    fontSize: '12px',
    lineHeight: '15px',
    fontWeight: 400,
    color: theme.colors.textButton,
    textAlign: 'justify'
  },
  fields: {
    '& .MuiOutlinedInput-root': {
      borderRadius: '36px',
      fontSize: '12px',
      height: '36px'
    },
    '& .MuiInputBase-root': {
      '& input': {
        WebkitBoxShadow: '0 0 0 1000px white inset'
      }
    }
  },
  formDescription: {
    '& .MuiOutlinedInput-root': {
      borderRadius: '18px',
      fontSize: '12px',
      height: '99px'
    },
    '& .MuiInputBase-root': {
      '& input': {
        WebkitBoxShadow: '0 0 0 1000px white inset'
      }
    }
  },
  modalCancelButton: {
    width: '137px',
    textTransform: 'none',
    color: theme.colors.basicDisabledButtonColor,
    fontSize: '18px',
    fontWeight: 700
  },
  modalNextButton: {
    borderRadius: '36px',
    width: '137px',
    textTransform: 'none',
    background: theme.colors.iconBlue,
    borderColor: theme.colors.iconBlue,
    color: 'white',
    fontSize: '18px',
    fontWeight: 700
  },
  titleText: {
    fontSize: '16px',
    fontWeight: 600
  },
  customWidth: {
    width: '100%'
  },
  topContainer: {
    marginTop: '12px',
    display: 'flex',
    width: '100%',
    alignItems: 'center'
  },
  infoIcon: {
    fontSize: '14px',
    fontWeight: 500,
    color: theme.colors.text
  },
  buttonsContainer: {
    marginTop: '50px',
    display: 'flex',
    justifyContent: 'space-around'
  }
}))
